/**
 * SkyVision ACCESS — Ausstiegsfenster mit Klapparm-Antrieb.
 *
 * Preislich wie COMFORT (FIXED-Tabelle + Motor + Steuerung), aber
 * immer zwei Antriebe. Maße nach aktueller Produktseite:
 * kurze Seite 1000 mm, lange Seite 1000–1800 mm, Aufsatzkranz 291 mm.
 */

import {
  calculateComfortPrice,
  MotorRules,
  SKYVISION_COMFORT_CONFIG,
  type ComfortCatalogPrices,
} from './priceConfigComfort';

export const ACCESS_MOTOR_RULES: MotorRules = {
  dualAreaDouble: 0,
  dualAreaTriple: 0,
  dualMaxSide: 0,
};

export const SKYVISION_ACCESS_CONFIG = {
  baseDimensions: {
    width: 1000,
    length: 1000,
    height: 291,
  },
  glassTypes: {
    double: {
      name: '2-fach Isolierverglasung',
      description: 'Sehr gute Wärmedämmung (Ug-Wert 1,1)',
      minHeight: 291,
      maxArea: 1.8,
    },
    triple: {
      name: '3-fach Isolierverglasung',
      description: 'Maximale Energieeffizienz (Ug-Wert 0,7)',
      minHeight: 291,
      maxArea: 1.8,
    },
  },
};

export const ACCESS_DIMENSIONS = {
  MIN_WIDTH: 1000,
  MAX_WIDTH: 1000,
  MIN_LENGTH: 1000,
  MAX_LENGTH: 1800,
  MIN_HEIGHT: 291,
  MAX_HEIGHT: 750,
  MAX_AREA: 1.8,
  STEP_SIZE: 100,
};

const ACCESS_FALLBACK_CATALOG: ComfortCatalogPrices = {
  motorDual: SKYVISION_COMFORT_CONFIG.motor.pricePerMotor * 2,
  wcc106: SKYVISION_COMFORT_CONFIG.motor.controls.wcc106.price,
};

export function calculateAccessPrice(
  width: number,
  length: number,
  height: number,
  glassType: 'double' | 'triple' | null = 'double',
  controlType: 'wcc103' | 'wcc106' | null = 'wcc106',
  catalogPrices?: ComfortCatalogPrices,
) {
  return calculateComfortPrice(
    width,
    length,
    height,
    glassType,
    controlType ?? 'wcc106',
    catalogPrices ?? ACCESS_FALLBACK_CATALOG,
    ACCESS_MOTOR_RULES,
  );
}

export function getAccessMinDimensions() {
  return {
    width: ACCESS_DIMENSIONS.MIN_WIDTH,
    length: ACCESS_DIMENSIONS.MIN_LENGTH,
    height: ACCESS_DIMENSIONS.MIN_HEIGHT,
  };
}

export function getAccessDimensions() {
  return ACCESS_DIMENSIONS;
}

/** Ab-Preis: 1000 × 1000 mm, 2-fach, zwei Antriebe, WCC106. */
export function getAccessStartingPrice(): number {
  return Math.round(
    calculateAccessPrice(1000, 1000, 291, 'double', 'wcc106').totalPrice,
  );
}
